export const UIConfig = {
  defaultSetpoint: 15,
  upperSetpointLimit: 26,
  lowerSetpointLimit: 5,
  selectedBEEsLimit: 20,
};
